import { render, staticRenderFns } from "./ChannelPicker.vue?vue&type=template&id=803deb2a"
import script from "./ChannelPicker.vue?vue&type=script&lang=js"
export * from "./ChannelPicker.vue?vue&type=script&lang=js"
import style0 from "./ChannelPicker.vue?vue&type=style&index=0&id=803deb2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports